import { render } from "./uploadImages.vue?vue&type=template&id=525910a8"
import script from "./uploadImages.vue?vue&type=script&lang=js"
export * from "./uploadImages.vue?vue&type=script&lang=js"

import "./uploadImages.vue?vue&type=style&index=0&id=525910a8&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__